module.exports = __webpack_public_path__ + "img/position_pro_img3.9261b0f2.png";